/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WaveSplitsGraphQueryVariables = {|
  eventId: string,
  roundNum: number,
  eventCourseId: string,
|};
export type WaveSplitsGraphQueryResponse = {|
  +pgaWaveSplitsForRound: ?{|
    +roundAvg: ?any,
    +amAvg: ?any,
    +pmAvg: ?any,
    +minToPar: ?number,
    +maxToPar: ?number,
    +amScores: ?$ReadOnlyArray<?{|
      +score: ?number,
      +num: ?number,
    |}>,
    +pmScores: ?$ReadOnlyArray<?{|
      +score: ?number,
      +num: ?number,
    |}>,
  |}
|};
export type WaveSplitsGraphQuery = {|
  variables: WaveSplitsGraphQueryVariables,
  response: WaveSplitsGraphQueryResponse,
|};
*/


/*
query WaveSplitsGraphQuery(
  $eventId: ID!
  $roundNum: Int!
  $eventCourseId: ID!
) {
  pgaWaveSplitsForRound(eventId: $eventId, roundNum: $roundNum, eventCourseId: $eventCourseId) {
    roundAvg
    amAvg
    pmAvg
    minToPar
    maxToPar
    amScores {
      score
      num
    }
    pmScores {
      score
      num
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventCourseId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roundNum"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "score",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "num",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "eventCourseId",
        "variableName": "eventCourseId"
      },
      {
        "kind": "Variable",
        "name": "eventId",
        "variableName": "eventId"
      },
      {
        "kind": "Variable",
        "name": "roundNum",
        "variableName": "roundNum"
      }
    ],
    "concreteType": "PGATourWaveSplitsForRoundType",
    "kind": "LinkedField",
    "name": "pgaWaveSplitsForRound",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roundAvg",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amAvg",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pmAvg",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minToPar",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxToPar",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourWaveSplitType",
        "kind": "LinkedField",
        "name": "amScores",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourWaveSplitType",
        "kind": "LinkedField",
        "name": "pmScores",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WaveSplitsGraphQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WaveSplitsGraphQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c9e9b527c6b5f41631f63c258aa83ffa",
    "id": null,
    "metadata": {},
    "name": "WaveSplitsGraphQuery",
    "operationKind": "query",
    "text": "query WaveSplitsGraphQuery(\n  $eventId: ID!\n  $roundNum: Int!\n  $eventCourseId: ID!\n) {\n  pgaWaveSplitsForRound(eventId: $eventId, roundNum: $roundNum, eventCourseId: $eventCourseId) {\n    roundAvg\n    amAvg\n    pmAvg\n    minToPar\n    maxToPar\n    amScores {\n      score\n      num\n    }\n    pmScores {\n      score\n      num\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4344c215a152448c3d0cd0fc5b871f87';

module.exports = node;
